// TODO: Delete this and expose the theme palette colors
export enum CardColors {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  CONSULTATION = "info",
  PRESCRIPTION = "pink",
  INVESTIGATION = "blue",
  TRANSPARENT = "transparent",
  DISABLED = "disabled",
  REFERRAL = "purple",
}
